import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddUnderContractData from "./components/AddUnderContractData";

const initialData = {
  executed_id: "",
  property: { id: "", name: "" },
  company_gcl: "",
  contract_price: "",
  contract_cap_rate: "",
  created_at: "",
  gcl_broker_representing_seller: "",
  gcl_broker_representing_buyer: "",
  gcl_bds_seller: "",
  gcl_bds_buyer: "",
};


const AddUnderContractModal = ({ showModal, onClose, onSuccess, onCallApi }) => {
  const [config] = useAuth();
  const [disable, setDisable] = useState(false);
  const [addexecutedData, setExecutedData] = useState(initialData);
  const [error, setError] = useState();
  const [addpipelineError, setAddpipelineError] = useState({ pipelinename: "" });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDollar, setIsDollar] = useState(false)
  const [isContractCapRateDollar, setIsContractCapRateDollar] = useState(false)
  const [isSellerBDSDollar, setIsSellerBDSDollar] = useState(false)
  const [isBuyerBDSDollar, setIsBuyerBDSDollar] = useState(false)
  const [isSellerBrokerDollar, setIsSellerBrokerDollar] = useState(false)
  const [isBuyerBrokerDollar, setIsBuyerBrokerDollar] = useState(false)


  const handleClose = () => {
    setDisable(false);
    setExecutedData(initialData);
    onClose();
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      portfolio: addexecutedData?.portfolio === 1 ? 1 : 0,
      executed_id: addexecutedData.executed_id,
      property: addexecutedData.property,
      company_gcl: addexecutedData.company_gcl,
      contract_price: addexecutedData.contract_price,
      contract_cap_rate: addexecutedData.contract_cap_rate,
      created_at: addexecutedData.created_at
    };

    axios
      .post(`${BASE_URL}/add-undercontract`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          console.error("API Error:", err.response.data.errors);
        } else {
          console.error("Unexpected Error:", err);
        }
        setDisable(false);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleChange = (value, name) => {
    setAddpipelineError({ ...error, [name]: "" });
    setExecutedData({ ...addexecutedData, [name]: value });
  };


  return (
    <Modal title={"Add Under Contract"} desc={"Add the Under Contract information."} show={showModal} onClose={handleClose}>
      <AddUnderContractData
        addexecutedData={addexecutedData}
        setExecutedData={setExecutedData}
        handleSubmit={handleSubmit}
        isSidebarOpen={isSidebarOpen}
        onSetError={(value) => setAddpipelineError(value)}
        showModal={showModal}
        handleChange={handleChange}
        disable={disable}
        error={addpipelineError}
        onClose={handleClose}
        isDollar={isDollar}
        setIsDollar={setIsDollar}
        isContractCapRateDollar={isContractCapRateDollar}
        setIsContractCapRateDollar={setIsContractCapRateDollar}
        isSellerBDSDollar={isSellerBDSDollar}
        setIsSellerBDSDollar={setIsSellerBDSDollar}
        isBuyerBDSDollar={isBuyerBDSDollar}
        setIsBuyerBDSDollar={setIsBuyerBDSDollar}
        isSellerBrokerDollar={isSellerBrokerDollar}
        setIsSellerBrokerDollar={setIsSellerBrokerDollar}
        isBuyerBrokerDollar={isBuyerBrokerDollar}
        setIsBuyerBrokerDollar={setIsBuyerBrokerDollar}
      />
    </Modal>
  );
};

export default AddUnderContractModal;
